import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import CampaignForm from './forms/CampaignForm';
import CampaignList from './lists/CampaignList';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";

class CampaignEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.setState({editorHeader: data.name});
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        return <Fragment>
                <List
                    {...this.props}
                    collapsed={this.props.collapsed || false}
                    theme="default"
                    header={"Kampányok"}
                    footer={[
                        <Button
                            key="0"
                            disabled={this.props.isLoading}
                            color="default"
                            onClick={this.pristineForm}
                        >
                            Új
                        </Button>
                    ]}
                >
                    <CampaignList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
                </List>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header="Kampány"
                    footer={[
                        <Button
                            key="0"
                            disabled={!this.props.dirty || this.props.isLoading}
                            color="primary"
                            className="pull-right"
                            onClick={this.saveForm}
                        >
                            Mentés
                        </Button>
                    ]}
                >
                    <CampaignForm {...this.props} />
                </Editor>
        </Fragment>;
    }
}

export default createEditor({componentName: "Campaign", WrappedComponent: CampaignEditor});
